export const kStorageKey = {
  SidebarCollapsible: 's_co',
  UserInfo: 'u_in',
  Cookies: {
    accessToken: 'ac_t',
    refreshToken: 're_t',
  },
} as const;
